import { DASHBOARD_PAGE } from '@townsquare/config/routes';
import { DASHBOARDS_PATH } from '@townsquare/config/routes';
import { createSiteRoute } from '@townsquare/router/create-route';
import { SiteHomePageRoute } from '@townsquare/router/route-types';

export const dashboardRoute: SiteHomePageRoute = createSiteRoute({
	exact: true,
	name: DASHBOARD_PAGE,
	path: DASHBOARDS_PATH + '/:slug/:mode?',
	layout: 'expanded',
});
